import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteSubscriptionsUrl } from "../../../config";
import { Status } from "../../../common/constants";
import { RootState } from "../../../store";
import api from "../../../api";
import { IInitialSliceState } from "../../../common/types/commonTypes";

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  msg: null,
};

interface IDeleteSubscriptionResponse {
  message: string;
}

interface IDeleteSubscriptionModalPayload {
  subscriptionId: string;
}

const DELETE_SUBSCRIPTION: string = "deleteSubscription";

export const deleteSubscriptionModal = createAsyncThunk(
  DELETE_SUBSCRIPTION,
  async (
    deleteSubscriptionModalPayload: IDeleteSubscriptionModalPayload,
    { rejectWithValue }
  ) => {
    const { subscriptionId } = deleteSubscriptionModalPayload;
    try {
      const response = await api.delete<IDeleteSubscriptionResponse>(
        deleteSubscriptionsUrl + `?subscriptionId=${subscriptionId}`
      );
      const deleteSubscriptionResponse: IDeleteSubscriptionResponse =
        response.data;
      return deleteSubscriptionResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const deleteSubscriptionModalSlice = createSlice({
  name: DELETE_SUBSCRIPTION,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteSubscriptionModal.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(deleteSubscriptionModal.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.status = Status.SUCCESS;
      })
      .addCase(deleteSubscriptionModal.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          "Unknown error occurred";
        state.status = Status.FAILED;
      });
  },
});

export const selector = (state: RootState) => state.deleteSubscriptionApi;

export const reducer = deleteSubscriptionModalSlice.reducer;
